import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import CompareSessionStorageProducts from './CompareSessionStorageProducts.jsx';

export default function initCompareSessionStorageProducts() {
  const mountEl = document.querySelector('[data-component="compare-session-storage-products"]');

  if (mountEl) {
    ReactDOM.render(
      <Provider store={window.appState}>
        <CompareSessionStorageProducts />
      </Provider>, mountEl
    );
  }
}
